import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavStateService {
  private readonly mobileBreakpoint = 979;
  private readonly _collapsed = signal(this.isMobile());

  /** Read-only signal — true = sidebar collapsed */
  readonly collapsed = this._collapsed.asReadonly();

  /** Observable for components that need to subscribe (CSS accordion, standalone) */
  private readonly _state$ = new BehaviorSubject<{ mobileViewActivated: boolean; menuOnTop: boolean }>(this.buildStore());
  readonly state$ = this._state$.asObservable();

  toggle(): void {
    this._collapsed.update(v => !v);
    this._state$.next(this.buildStore());
  }

  set(value: boolean): void {
    this._collapsed.set(value);
    this._state$.next(this.buildStore());
  }

  collapseForMobile(width = this.getViewportWidth()): void {
    if (this.isMobile(width)) {
      this._collapsed.set(true);
    }
    this._state$.next(this.buildStore(width));
  }

  buildStore(width = this.getViewportWidth()) {
    return {
      mobileViewActivated: this.isMobile(width),
      menuOnTop: false,
    };
  }

  private isMobile(width = this.getViewportWidth()): boolean {
    return width < this.mobileBreakpoint;
  }

  private getViewportWidth(): number {
    return typeof window === 'undefined' ? this.mobileBreakpoint : window.innerWidth;
  }
}
